import { useMutation } from '@tanstack/react-query'
import { AxiosError } from 'axios'
import { ServerCrash } from 'lucide-react'
import { useTranslation } from 'react-i18next'
import { toast } from 'react-toastify'

import { Toast } from '@/common/components/Toast'
import { api, ApiError } from '@/lib/axios'
import { queryClient } from '@/lib/tanstack'

async function postPostsPinned(postId: string) {
  return api.backend.post(`/posts-pinned`, {
    postId,
  })
}

export function useTogglePinPost() {
  const { t } = useTranslation('panel')

  const { mutateAsync, isPending } = useMutation<
    unknown,
    AxiosError<ApiError>,
    string
  >({
    mutationFn: (postId: string) => postPostsPinned(postId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: ['/posts/paginate'],
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: ['/posts-slider/paginate'],
        exact: false,
      })
      queryClient.invalidateQueries({
        queryKey: ['/posts/paginate/pinned'],
        exact: false,
      })
    },
    onError: (error) => {
      toast(Toast, {
        data: {
          type: 'danger',
          icon: ServerCrash,
          title: t('news.use_toggle_pin_post.toast_error.title'),
          description:
            error?.response?.data?.friendlyMessage ||
            t('news.use_toggle_pin_post.toast_error.description'),
        },
      })
    },
  })

  const handleTogglePinPost = async (postId: string) => {
    await mutateAsync(postId)
  }

  return { handleTogglePinPost, isTogglingPinPost: isPending }
}
